<template>
  <div class="auth-login">
    <el-form ref="form" :model="form" label-width="80px">
      <el-form-item label="团队ID">
        <el-input v-model="form.corpId" />
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input v-model="form.userId" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { userLoginApi } from '../utils/api/user'
import { loginSuccess } from '../utils/user/login'
import Store from '@/store/index'
export default {
  data() {
    return {
      form: {
        corpId: 'dingc7c13fc9fb029197f5bf40eda33b7ba0',
        userId: '18825d4dc4ae4b56acc34de4b2a1cdc7' // 377b1bb456574abab75eb01d68623400
        // corpId: 'ww46d8937c612d235c', // 企微
        // userId: '7e4e1f05261a4fdc8f23e1e5a02af51a' // c81c84e3dbf949dfbd3f81d20ed10d07
        // corpId: '1b24c58e411f975f',
        // userId: '723f25c480ff456b92f0294f4df555fe' // 飞书

      },
      loginCode: ''
    }
  },
  mounted() {
    Store.commit('user/setLoading', false)
  },
  methods: {
    async onSubmit() {
      const { corpId, userId } = this.form
      if (!corpId || !userId) return
      const { code, result } = await userLoginApi(this.form)
      if (code !== 10000) throw new Error(result)
      return loginSuccess(code, result)
    },
    openAuth() {
      console.log(this.loginCode, 'this.loginCode')
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-login {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  .el-form {
    width: 100%;
    max-width: 500px;
  }
}
</style>
